import React from 'react';
import './Section.css';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  alt?: boolean;
}

const Section: React.FC<SectionProps> = ({ children, className = '', alt = false, ...props }) => {
  const classes = `section ${alt ? 'alt' : ''} ${className}`;
  return (
    <section className={classes} {...props}>
      <div className="container">
        {children}
      </div>
    </section>
  );
};

export default Section;